module.exports = __webpack_public_path__ + "esomar.svg?daa1565b71dbda9d787120af958173ce";